import axios from '../axios'

/* 
 * 物流商模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/logistics/save',
        method: 'post',
        data
    })
}
// 查询
export const findPage = (data) => {
    return axios({
        url: '/logistics/findPage',
        method: 'post',
        data
    })
}
export const getStatus = (data) => {
    return axios({
        url: '/logistics/getStatus',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/logistics.js